import HomePage from './HomePage';
import GMETPage from './GMETPage';
import ProductsPage from './ProductsPage';
import AboutPage from './AboutPage';
import './App.css';

function App() {
  const pathname = window.location.pathname;
  const isGMET = pathname === '/gmet-tech';
  const isProducts = pathname === '/products';
  const isAbout = pathname === '/about';

  return (
    <div className="app-container">
      {isGMET ? <GMETPage /> : isProducts ? <ProductsPage /> : isAbout ? <AboutPage /> : <HomePage />}
    </div>
  );
}

export default App;
